
import { defineComponent, ref, reactive } from 'vue'
import eventService from "@/core/services/EventService";
import { errManager } from "@/core/config/Tools";
import type { FormInstance, FormRules } from "element-plus";

export default defineComponent({
    name: "medals-addedit-modal",
    props: {
        idevent: {
            type: null,
            required: true,
            default: 0
        }
    },
    setup(props) {
        const loading = ref(false)
        const isModalVisible = ref(false);
        const isModalAdd = ref(false)
        const idsport = ref(null)
        const idinstitution = ref(null)
        const listSports = ref<any>([])
        const listInstitution = ref<any>([])
        const ruleFormRef = ref < FormInstance > ()
        const form = reactive <any>({
            idevent: props.idevent,
            idsport: idsport.value,
            idinstitution : idinstitution.value,
            gold: 0,
            silver:0,
            bronze: 0
        })
        const loaderForm = ref(false)
        const rules = reactive < FormRules > ({
            name: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
        })

        const openModal = () => {
            isModalVisible.value = true;
        }

        const onOpened = () => {
            getSports()
        }

        //lista de deportes por evento
        const getSports = async () => {
            loading.value = true
            listSports.value.length = 0
            await eventService.getSports({ idevent: props.idevent })
                .then((res) => {
                    listSports.value = res.data
                    loading.value = false
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        //lista de instituciones en base al deporte
        const getListaInstitution = async () => {
            loading.value = true
            idinstitution.value = null
            listInstitution.value.length = 0
            await eventService.getClubs({ idevent: props.idevent, idsport: idsport.value })
                .then((res) => {
                    listInstitution.value = res.data
                    loading.value = false
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const onClosed = () => {
            resetForm(ruleFormRef.value)
        }

        const saveMedalla = async() => {
            loaderForm.value = true
            form.idsport = idsport.value
            form.idinstitution = idinstitution.value
            await eventService.options('medals', form)
            .then((res) => {
                    alert(res.data.message)
                    loaderForm.value = false
                    if(res.data.status == 'success')
                    isModalAdd.value = false
                }).catch(({ response }) => {
                    loaderForm.value = false
                    errManager(response)
                })

        }

        return {
            isModalVisible,
            isModalAdd,
            loading,
            idsport,
            idinstitution,
            listSports,
            listInstitution,
            form,
            rules,
            loaderForm,
            ruleFormRef,

            //events
            openModal,
            onOpened,
            getSports,
            getListaInstitution,
            saveMedalla,
            onClosed
        }

    },
})
